export const GET_ALL_BRAND_REQUEST = "GET_CUSTOMERS_REQUEST";
export const GET_ALL_BRAND_FAILURE = "GET_CUSTOMERS_FAILURE";
export const GET_ALL_BRAND_SUCCESS = "GET_CUSTOMERS_SUCCESS";